import React from 'react'
import type { ReactNode, FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Typography as BaseTypography } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme) =>
  createStyles({
    h1: {
      marginBottom: '0',
      fontSize: '26px',
      whiteSpace: 'nowrap',
    },
    h2: {
      marginBottom: '16px',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '23px',
      letterSpacing: '-0.26px',
      '& span': {
        marginLeft: '14px',
        verticalAlign: 'bottom',
        fontSize: '16px',
        fontWeight: 500,
        color: theme.colors.grey600,
      },
    },
    subtitle1: {
      display: 'inline-block',
      margin: '8px 0 0 20px',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '17px',
      letterSpacing: '-0.26px',
      color: theme.colors.grey600,
    },
    body1: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '-0.2px',
      color: theme.colors.grey600,
    },
    body2: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
      letterSpacing: '-0.23px',
      color: theme.colors.grey480,
    },
  }),
)

type TypographyProps = {
  children: ReactNode
  variant: 'h1' | 'h2' | 'subtitle1' | 'body1' | 'body2'
  className?: string
}

export const Typography: FC<TypographyProps> = ({
  children,
  variant,
  className,
}) => {
  const classes = useStyles()

  return (
    <BaseTypography
      variant={variant}
      classes={{
        [variant]: `${classes[variant]} ${className || ''}`,
      }}
    >
      {children}
    </BaseTypography>
  )
}
